import { Alert, Link, Box, Text, List } from '@nimbus-ds/components';
import { Link as LinkRouter } from 'react-router-dom';
import {
  OrderDetailsProductDto,
  OrderDetailsResponseDto,
} from '@tiendanube/common';

interface InvoiceErrorsProps {
  readonly resolvedErrors: any[];
  readonly orderDetails: OrderDetailsResponseDto;
  readonly t: any;
}

function InvoiceErrors({
  resolvedErrors,
  orderDetails,
  t,
}: InvoiceErrorsProps) {
  const nvmErrors = resolvedErrors.filter(
    (errorGroup: any) =>
      errorGroup.error_group === 'NVM' && errorGroup.error_code === 'ENR_104',
  );

  const errorProductIds = nvmErrors
    .map((err: any) => err.metadata?.product_id)
    .filter(Boolean);

  const filteredProductIds = errorProductIds.filter(
    (id, idx, arr) => arr.indexOf(id) === idx,
  );

  const getProductLinkList = () => (
    <Box marginTop="1" marginBottom="none">
      <List as="ul" color="danger-textLow">
        {filteredProductIds.map((productId) => {
          const product = orderDetails.products.find(
            (p: OrderDetailsProductDto) => p.productId === productId,
          );
          const productName = product?.title || productId;
          return (
            <Box
              display="flex"
              alignItems="center"
              gap="2"
              color="danger-textLow"
              key={productId}
            >
              <Box
                width="5px"
                height="5px"
                borderRadius="full"
                backgroundColor="danger-textLow"
                style={{ flexShrink: 0 }}
              />
              <Link
                as={LinkRouter}
                textDecoration="none"
                to={`/products/${productId}`}
              >
                <Text color="danger-textLow" textDecoration="underline">
                  {productName}
                </Text>
              </Link>
            </Box>
          );
        })}
      </List>
    </Box>
  );

  if (nvmErrors.length > 0) {
    return (
      <Alert
        title={t('cardInvoice.alert.errorRequest.fiscalError.title')}
        appearance="danger"
        show
      >
        <Box>{getProductLinkList()}</Box>
        <Text fontSize="base" fontWeight="regular" color="danger-textLow">
          {t('cardInvoice.alert.errorRequest.fiscalError.update')}
        </Text>
      </Alert>
    );
  }

  return (
    <Alert
      title={t('cardInvoice.alert.errorRequest.title')}
      appearance="danger"
      show
    >
      <Box>
        {resolvedErrors.flatMap((errorGroup, index) =>
          errorGroup.errors.map((errMsg, subIndex) => (
            <Text
              key={`${index}-${subIndex}`}
              fontSize="base"
              fontWeight="regular"
            >
              {errMsg}
            </Text>
          )),
        )}
      </Box>
    </Alert>
  );
}

export default InvoiceErrors;
